// extracted by mini-css-extract-plugin
export default {"root":"LanguageBar_root__fXg6f","separator":"LanguageBar_separator__MI17i"};